import {gql} from "apollo-angular";
import {baseResponse} from "../../base.graphql";


export const feedbackCategoryFields = `
    id
    categoryUniqueId
    categoryName
`;

export const CREATE_FEEDBACK_CATEGORY = gql`
    mutation CreateFeedbackCategory($input: FeedbackCategoryInput!) {
        createFeedbackCategory(input: $input) {
            response {
                ${baseResponse}
            }
            data {
                ${feedbackCategoryFields}
            }
        }
    }
`;

export const UPDATE_FEEDBACK_CATEGORY = gql`
    mutation UpdateFeedbackCategory($input: FeedbackCategoryInput!) {
        updateFeedbackCategory(input: $input) {
            response {
                ${baseResponse}
            }
            data {
                ${feedbackCategoryFields}
            }
        }
    }
`;

export const DELETE_FEEDBACK_CATEGORY = gql`
    mutation DeleteFeedbackCategory($categoryUniqueId: String!) {
        deleteFeedbackCategory(categoryUniqueId: $categoryUniqueId) {
            response {
                ${baseResponse}
            }
        }
    }
`;

export const GET_ALL_FEEDBACK_CATEGORIES = gql`
    query GetAllFeedbackCategories {
        getAllFeedbackCategories {
            response {
                ${baseResponse}
            }
            data {
                ${feedbackCategoryFields}
            }
        }
    }
`;
